import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {HomepageMock} from './mock'

export const getHomepageData = createAsyncThunk(
  'getHomepageData',
  async (_, store: any) => {
    // return HomepageMock
    const resp = await http.post(
      '/live/activity/vip_team_rank_homepage',
      {},
      {
        store: window.store,
      }
    )
    return resp.data?.data
  }
)

const initialState: {
  homepage?: {
    status?: number
    is_act?: boolean
    phase_countdown?: number
    date_countdown?: number
    contest_start?: string
    has_team?: boolean
    is_captain?: boolean
    captain_mid?: number
    captain_member?: {
      id: number
      name: string
      avatar: string
    }
    team_member_cnt?: number
    date_list?: string[]
  }
} = {
  homepage: {},
}

export const BigRTeamSlice = createSlice({
  name: 'BigRTeam',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getHomepageData.fulfilled, (state, action) => {
      Object.assign(state.homepage, action.payload)
    })
  },
})

export default BigRTeamSlice.reducer
export const BigRTeamActions = BigRTeamSlice.actions
